import Main from '../../views/main'
export default [
  /* -------------- 首页 -------------- */
  {
    path: '/',
    name: 'L',
    redirect: '/home',
    // 此处组件的名称必须是MAIN_COMPONENT_NAME(default: Main)
    component: Main,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Home/homePage'),
        meta: {
          label: '首页',
          singleton: true,
          subText: '',
          icon: 'mdi-home',
          persistent: true, // 持久tab，不可关闭，tab在最左侧
          showFooter: true, // 显示系统footer
          recoverable: false, // 刷新浏览器时是否重新加载此tab
          hideInMenu: false, // 在侧边导航中隐藏
          hideInBread: false, // 在侧边导航中隐藏
          noLoginRequired: false, // 无需登录即可进入
          access: [], // 页面权限数组
        }
      }
    ],
    meta: {
      hideInBread: true,
    }
  },
]
